@if (rows().length) {
  <div
    class="company-search-results__list"
    role="list"
    aria-label="Companies"
    scrollingList
    (scrollEndEvent)="onScrollEnd()"
  >
    @for (row of rows(); track row.id) {
      <div
        company-tree-row
        [row]="row"
        (selectCompany)="onSelect($event)"
      ></div>
    }
    <!-- Inside the list, which is the scroll container: a sibling outside it
         would never reach the end of the results. -->
    @if (loadingMore()) {
      <div
        class="company-search-results__loading-more"
        role="none"
        aria-hidden="true"
      >
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    }
  </div>
}
@if (errorMessage()) {
  <div class="company-search-results__error" role="alert">
    <strong>{{ errorMessage() }}</strong>
    <button
      type="button"
      class="company-search-results__retry"
      (click)="onRetry()"
    >
      Retry
    </button>
  </div>
}
<!-- Mounted rather than wrapped in `@if`: the copy replaces a list the user was
     watching, and a live region inserted at that moment is not reliably
     announced. -->
<div
  class="company-search-results__empty"
  [class.company-search-results__empty--shown]="showEmptyState()"
  role="status"
>
  @if (showEmptyState()) {
    <div class="company-search-results__empty-art" aria-hidden="true">
      <img
        src="/images/no-search-results.svg"
        alt=""
        aria-hidden="true"
        width="48"
        height="48"
      />
    </div>
    @if (searchedCompanyName(); as name) {
      <p class="company-search-results__empty-copy">
        No search results in <strong>{{ name }}</strong
        >.
      </p>
      <p class="company-search-results__empty-copy">
        Looking for a parent company?
      </p>
      <button
        type="button"
        class="company-search-results__widen"
        (click)="onWidenSearch()"
      >
        Show all companies
      </button>
    } @else {
      <p class="company-search-results__empty-copy">No search results found</p>
    }
  }
</div>
